// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"240":"923e9c18","532":"f6a1c860","620":"6878a1d3","930":"643fd255"}[chunkId] + ".chunk.js";
};